<script>
import vuetableFormatter from '@src/mixins/vuetableFormatters'

const i18nCommon = 'COMMON'

export default {
    mixins: [vuetableFormatter],
    data() {
        return {
            userChildrenFields: [
                {
                    key: 'name',
                    label: this.getI18n(i18nCommon, 'name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: this.getI18n(i18nCommon, 'email'),
                    sortable: true,
                },
                {
                    key: 'role.0.alias',
                    label: this.getI18n(i18nCommon, 'role'),
                    sortable: true,
                },
                {
                    key: 'long_name',
                    label: this.getI18n(i18nCommon, 'address'),
                    sortable: true,
                },
                {
                    key: 'timezone',
                    label: this.getI18n(i18nCommon, 'timezone'),
                    sortable: true,
                    formatter: this.formatTimezone,
                },
                {
                    key: 'app_version',
                    label: this.getI18n(i18nCommon, 'app_version'),
                    sortable: true,
                },
            ],
        }
    },
}
</script>
